export default __webpack_public_path__ + "static/media/avatar.a7cd449c.png";